const ContactEmail = (props: any) => {
    const textAlign = props.textAlign ? props.textAlign : "center";
    const displayProp = props.display ? props.display : "inline";
    return (
        <>
            <span className="inter-thin" style={{"textAlign": textAlign, "margin": "0", "display": displayProp}}>оffice@kateinternational.eu</span>
        </>
    )
}

export default ContactEmail;